import { Image } from '@vinted/web-ui'

import { InfluencerLifestyleCardModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

export const LifestyleSectionCard = ({
  title,
  description,
  image,
  index,
}: InfluencerLifestyleCardModel & { index: number }) => (
  <article className="influencer__lifestyle-card" data-testid="influencer__lifestyle-card">
    <div className="influencer__lifestyle-card-image">
      <Image
        src={image.x2Url}
        srcset={`${image.x1Url} 1x, ${image.x2Url} 2x, ${image.x3Url} 3x`}
        scaling={Image.Scaling.Fill}
        testId={`lifestyle-card-image-${index}`}
      />
    </div>
    <h3 className="influencer__lifestyle-card-title">{title}</h3>
    <p className="influencer__lifestyle-card-description">{description}</p>
  </article>
)
